import { activities } from './types';

export const requestActivities = (queryArgs, promise) => ({
  type: activities.request,
  queryArgs,
  promise,
});

export const requestActivitiesSuccess = (response) => ({
  type: activities.success,
  response,
});

export const requestActivitiesFailure = (error) => ({
  type: activities.failure,
  error,
});
